export enum CustomToastContentType {
  exportedFile = "exported-file",
  quickAnalysisRetry = "quick-analysis-retry",
}
